<template>
  <v-dialog @update:returnValue="setEditItemIdZero" v-model="dialogResult" max-width="500px" persistent>
    <v-card>
      <v-card-text class="text-md-center">
        <v-flex xs12 sm6 md12>
          <v-text-field label="Name" v-model="itemData.name"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-text-field type="number" label="Amount" v-model="itemData.amount"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-checkbox label="Is available" v-model="itemData.is_available"></v-checkbox>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-checkbox label="Is external vendor" v-model="itemData.is_vendor"></v-checkbox>
        </v-flex>
        <v-flex xs12 sm6 md12 class="text-md-left">
          <ItemCheckList v-if="itemLoaded" :item-id="itemData.id" :item-type="itemType"></ItemCheckList>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat @click.stop="editItemData">Save</v-btn>
        <v-btn color="primary" flat @click.stop="dialogClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import dialogMixins from '@/mixins/EditResourceDialog'
  import itemTypesMixins from '@/mixins/ItemTypes'
  import ItemCheckList from '@/components/ItemCheckList'

  export default {
    components: { ItemCheckList },
    mixins: [ dialogMixins, itemTypesMixins ],
    data () {
      return {
        resource: 'services'
      }
    },
    computed: {
      itemType () {
        return this.serviceTypeID
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AppEditServicesDialog.vue?12f8b54f